(function ($) {

  let playButton = $('.js-video-play');
  let video = playButton.prev('.js-video').find('iframe');

  playButton.click(function(e){
    e.preventDefault();
    const player = new Vimeo.Player(video[0]);
    setTimeout(function(){
      playButton.fadeOut(500,function(){      
        player.play();
      });
    }, 100);
  });

})(jQuery);
